import UserProfile from 'views/User/UserProfile'
import UserNews from './holders/UserNews'
import UserActivities from "views/User/UserActivities";

export const userRouteEntities = [
  {
    path: 'home',
    component: UserNews,
    breadcrumbName: (t) => t('updates'),
  },
  {
    path: 'activities',
    component: UserActivities,
    breadcrumbName: (t) => t('activities'),
    isInvisible: ({item, isSm}) => !!!isSm,
  },
  {
    path: 'profile',
    component: UserProfile,
    breadcrumbName: (t) => t('personal information'),
    isInvisible: ({ item }) => false,
  },
]
